module.exports = __webpack_public_path__ + "img/查看全部期刊.2a59b355.png";